import classNames from 'classnames'
import React from 'react'

import SpinnerSvgGatsby from './img/spinner.svg'

export interface LoadingProps {
  className?: string
}

/**
 * @param props - The props as defined in the interface.
 * @param props.className - Additional classes
 * @returns JSX for the Spinner
 */
export default function Loading({className}: LoadingProps): React.ReactElement {
  return (
    <>
      <SpinnerSvgGatsby className={classNames('animate-spin', className)} />
      <span aria-busy="true" className="sr-only" role="status">
        Loading
      </span>
    </>
  )
}
